import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { disableAllMenu } from 'modules/actions/statusMenu';
const SideMenu = ({ styleDef, images }) => {
  const sideMenuStatus = useSelector(state => state.isActive.sideMenu);
  const dispatch = useDispatch();
  const settings = {
    dots: 'false',
    infinite: 'false',
    speed: 500,
    slidestoshow: 1,
    slidestoscroll: 1,
  };
  const guideClose = () => {
    dispatch(disableAllMenu());
  };
  return (
    <div className="_guide_area" style={styleDef}>
      <div className="_guide_div" {...settings}>
        <Slider {...settings}>
          <div className="_guide_image">
            <img src="/images/guide/introduce_1.png" alt="" />
          </div>
          <div className="_guide_image">
            <div className="_guide_close">
              <i className="ri-close-circle-line" style={{ color: '#37b7ff' }} onClick={() => guideClose()} />
              <p className="blink">안내창 닫기</p>
            </div>
            <img src="/images/guide/introduce_2.png" alt="" />
          </div>
        </Slider>
      </div>
    </div>
  );
};

SideMenu.propTypes = {
  styleDef: PropTypes.object,
  images: PropTypes.array,
};
SideMenu.defaultProps = {
  styleDef: {},
  images: [],
};
export default SideMenu;
